<template>
  <div>
    <div v-if="compact" class="lang-compact">
      <form-group :validations="validation">
        <div slot-scope="{ errors }">
          <div class="lang-compact-bar">
            <span class="lang-compact-label">زبان</span>
            <button
              v-for="item in languages"
              :key="item.id"
              type="button"
              :id="`language_item_${item.id}`"
              class="lang-chip"
              :class="{ active: String(value) === String(item.id) }"
              @click="$emit('input', item.id)"
            >
              {{ item.name }}
            </button>
          </div>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </div>
    <b-col v-else md="6">
      <form-group :validations="validation">
        <div slot-scope="{ errors, invalid }">
          <b-alert show class="overflow_div">
            <b-form-group :class="{ invalid }">
              <label>زبان</label>

              <div v-for="item in languages" :key="item.id">
                <input
                    type="radio"
                    :value="item.id"
                    :id="`language_item_${item.id}`"
                    @input="updateValue"
                    :class="{ invalid }"
                    name="language"
                />
                <label class="mr-1" :for="`language_item_${item.id}`">{{
                    item.name
                  }}</label>
              </div>

              {{ selectedItem }}
            </b-form-group>
          </b-alert>
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>
    </b-col>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {mapGetters} from "vuex";

export default {
  name: "LanguageBox",
  props: {
    validation: {},
    selectedItem: {},
    value: {},
    compact: {
      type: Boolean,
      default: false
    }
  },
  components: {FormGroup, FormErrorsManager},
  computed: {
    ...mapGetters({
      languages: "Language/getLanguages"
    })
  },
  methods: {
    updateValue(event) {
      this.$emit("input", event.target.value);
    },
    refreshLanguages() {
      this.$store.dispatch('Language/getLanguages')
    }
  }
}
</script>

<style scoped>
.overflow_div {
  width: auto;
  height: 300px !important;
  overflow-y: auto;
}

.lang-compact {
  min-width: 0;
}

.lang-compact-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.lang-compact-label {
  font-size: 12px;
  color: #6b7280;
  margin-left: 4px;
}

.lang-chip {
  border: 1px solid #e5e7eb;
  background: #fff;
  color: #374151;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 12px;
  line-height: 1.4;
  cursor: pointer;
}

.lang-chip.active {
  background: #0f766e;
  border-color: #0f766e;
  color: #fff;
}
</style>
